/** File location a warning or error originated from. */
export interface BundleMessageLocation {
  /** Path to file, relative to package root */
  file: string;

  /** 1-based */
  line?: number;

  /** 0-based, in bytes */
  column?: number;
}
